<template>
  <div class="bg-gray-100 p-4">
    <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
      Accommodatie toevoegen
    </p>
    <FormulateForm
      class="login-form flex-col flex"
      @submit="submitForm"
      v-model="values"
    >
      <FormulateInput
        name="naam"
        type="text"
        label="Naam *"
        placeholder="Naam"
        input-class="mi-input"
        label-class="mi-label"
        wrapper-class="flex-col
      flex"
        validation="required"
        :validation-messages="{ required: 'Naam is verplicht' }"
      />

      <div class="grid grid-cols-2 gap-4">
        <FormulateInput
          name="straat"
          type="text"
          label="Straat *"
          placeholder="Straat"
          input-class="mi-input"
          label-class="mi-label"
          wrapper-class="flex-col
      flex"
          validation="required"
          :validation-messages="{ required: 'Straat is verplicht' }"
        />
        <FormulateInput
          name="huisnummer"
          type="text"
          label="Huisnummer"
          placeholder="Huisnummer"
          input-class="mi-input"
          label-class="mi-label"
          wrapper-class="flex-col
      flex w-24"
        />
      </div>

      <div class="grid grid-cols-2 gap-4">
        <FormulateInput
          @validation="setPlaats"
          name="postcode"
          type="text"
          label="Postcode *"
          placeholder="Postcode"
          input-class="mi-input"
          label-class="mi-label"
          wrapper-class="flex-col flex"
          validation="bail|required|matches:/^[1-9][0-9]{3}[a-zA-Z]{2}$/"
          :validation-messages="{
            required: 'Postcode is verplicht',
            matches: 'Postcode moet format 1111AA hebben'
          }"
        />
        <div class="mt-6 capitalize">{{ plaatsnaam }}</div>
      </div>

      <div class="grid grid-cols-1 border border-black border-dashed mt-4 p-2">
        <FormulateInput
          type="group"
          name="voorzieningen"
          :repeatable="true"
          label="Voorzieningen"
          label-class="font-raleway font-bold text-xl text-mi-blue-500 uppercase"
          add-label="+ Voorziening toevoegen"
          remove-label="Verwijderen"
          remove-label-class="font-hairline"
          wrapper-class="flex-col flex"
          validation="min:1"
          :validation-messages="{ min: 'Minimaal 1 voorziening toevoegen' }"
        >
          <div class="mt-4 p-4">
            <FormulateInput
              type="select"
              name="voorziening_type"
              validation="required"
              value="onbekend"
              input-class="mi-input"
              label-class="mi-label"
              :options="this.options_services.map(this.shorten_label)"
              label="Type voorziening *"
              :validation-messages="{
                required: 'Type voorziening is verplicht'
              }"
            />
            <FormulateInput
              type="select"
              name="ondergrond"
              value="onbekend"
              validation="required"
              input-class="mi-input"
              label-class="mi-label"
              :options="this.options_substrates.map(this.shorten_label)"
              label="Type ondergrond *"
              :validation-messages="{
                required: 'Type ondergrond is verplicht'
              }"
            />
            <FormulateInput
              type="select"
              multiple="true"
              name="sporten"
              :value="[]"
              validation="required"
              input-class="mi-input"
              label-class="mi-label"
              :options="this.options_sports.map(this.shorten_label)"
              label="Sporten *"
              :validation-messages="{
                required: 'Minimaal 1 sport is verplicht'
              }"
            />
          </div>
        </FormulateInput>
      </div>
      <FormulateInput
        type="submit"
        label="Suggereer"
        v-if="showSuggestButton"
        class="mt-4"
        input-class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
      />
      <FormulateInput
        type="submit"
        label="Toevoegen"
        v-if="showAddButton"
        class="mt-4"
        input-class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
      />
    </FormulateForm>
    {{ error_msg }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddAccommodatie",
  data() {
    return {
      values: {},
      postcode_error: true,
      error_msg: null,
      plaats: null,
      plaatsnaam: null
    };
  },
  computed: {
    ...mapGetters({
      options_services: "services_flattened",
      options_substrates: "substrates_flattened",
      options_sports: "sports_flattened"
    }),
    showAddButton: function() {
      if (this.hasPermission("create accommodatie")) {
        return true;
      }
      return false;
    },
    showSuggestButton: function() {
      if (this.hasPermission("create accommodatie")) {
        return false;
      } else if (this.hasPermission("sugggest accommodatie")) {
        return true;
      }
      return false;
    }
  },
  methods: {
    setPlaats: async function(event) {
      if (!event.hasErrors) {
        const plaats = await this.$store.dispatch(
          "getPlaatsByPostcode",
          this.values["postcode"]
        );
        this.plaatsnaam = plaats["naam"];
        this.plaats = plaats["id"];
      } else {
        this.plaats = null;
        this.plaatsnaam = null;
      }
    },
    parseVoorziening: function(data) {
      return {
        sporten: data["sporten"].map(sport => ({
          id: sport
        })),
        ondergrond: { id: data.ondergrond },
        voorziening_type: { id: data.voorziening_type },
        accommodatie: this.$store.state.backend_data.current_accommodatie
      };
    },
    submitForm: function() {
      if (this.hasPermission("create accommodatie")) {
        this.addAccommodatie();
      } else if (this.hasPermission("sugggest accommodatie")) {
        this.addSuggestion();
      }
    },
    addAccommodatie: async function() {
      this.values["plaats"] = this.plaats;
      this.values["voorzieningen"] = this.values["voorzieningen"].map(
        this.parseVoorziening
      );
      this.values["straat"] =
        this.values["straat"] + " " + this.values["huisnummer"];
      const response = await this.$store.dispatch(
        "addAccommodation",
        this.values
      );

      if ("error" in response) {
        this.error_msg =
          "Er is een fout opgetreden bij het versturen van het formulier.";
      } else {
        this.$router.push({
          name: "Accommodatie",
          params: {
            id: response.msg
          }
        });
        this.error_msg = "Accommodatie toegevoegd.";
        this.values = {};
      }
    },
    addSuggestion: async function() {
      // To add a plaats, we needed a workaround. Somehow, Vue or Vue Formulate removes this.values.plaats on submit
      this.values["plaats"] = this.plaats;

      const response = await this.$store.dispatch("suggestAccommodation", {
        title: "Accommodatie toevoegen",
        description: JSON.stringify(this.values),
        object_name: "added_accommodatie"
      });

      if ("error" in response) {
        this.error_msg =
          "Er is een fout opgetreden bij het versturen van het formulier.";
      } else {
        this.error_msg =
          "Formulier succesvol verzonden. Een medewerker van het Mulier Instituut zal uw suggestie zsm verwerken.";
        this.values = {};
      }
      //empty form
    },

    shorten_label: item => ({
      // TODO: this is a temp bug fix for size of field
      // We may be able to fix this with CSS
      // This impacts position of mobile nav
      ...item,
      label: item.label.slice(0, 20)
    })
  }
};
</script>

<style>
.mi-input {
  @apply border-gray-500 border rounded-sm px-2 py-1 w-full;
}

.mi-label {
  @apply text-sm font-bold;
}

.formulate-input-group-repeatable {
  @apply border-gray-500 border border-dashed m-4 p-4 bg-gray-200;
}

.formulate-input-group-repeatable-remove {
  @apply ml-2 mb-4 bg-gray-100  text-red-600 font-semibold  py-2 px-4 border border-red-400 rounded;
}

.formulate-input-group-repeatable-remove:hover {
  @apply bg-red-600 text-white border-transparent;
}

.formulate-input-element--button--label {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}
.formulate-input-element--button--label:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}
</style>
